import styled from '@emotion/styled'

import {
  breakpoints,
  Button,
  colors,
  NativeLink,
  palette,
  spacing,
  Strong,
  Text,
  typography,
} from 'main/ui'

export const SubsidyEligibilityContainer = styled.div`
  align-items: start;
  border: 1px solid ${palette.oceanGreen};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: ${spacing.minorScale(5)}px ${spacing.majorScale(-3)}px;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: column;
    justify-content: space-between;
    margin: ${spacing.minorScale(5)}px 0;
  }
`

export const SubsidyEligibilityDivider = styled.div`
  border-top: 1px solid ${palette.oceanGreen};
  align-self: stretch;
`

export const TextContainer = styled.div`
  margin: ${spacing.minorScale(3)}px ${spacing.minorScale(6)}px;
`

export const StyledStrong = styled(Strong)`
  @media (min-width: ${breakpoints.lg}px) {
    font-size: 20px;
    line-height: 30px;
  }
`

export const StyledText = styled(Text)`
  color: ${palette.slate};
`

export const StyledLink = styled(NativeLink)<{ hasBorderRight?: boolean }>`
  font-weight: ${typography.fontWeight.light};
  border-right: ${props => (props.hasBorderRight ? `1px solid ${colors.border.default}` : '')};
  padding-right: ${props => (props.hasBorderRight ? `${spacing.majorScale(1)}px` : '0px')};
`

export const ButtonContainer = styled.div`
  margin-top: ${spacing.majorScale(3)}px;
  width: 320px;

  @media (min-width: ${breakpoints.lg}px) {
    margin-top: 0;
    width: 250px;
  }
`

export const CtaContainer = styled.div`
  margin-right: ${spacing.minorScale(2)}px;
`

export const CtaButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`
